import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { isDateWithin1Month } from "../utils/dateLimit";

// ---- แก้ไข: รับ userProfile จริง ----
export default function AddActivityCalendar({ userProfile }) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [activities, setActivities] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    activity: "",
    duration: "",
    note: "",
    category: "work",
  });
  const [error, setError] = useState("");

  // --- mock fetch/save (localStorage) ---
  const mockFetchActivities = (date) => {
    const data = JSON.parse(localStorage.getItem("calendarActivities") || "{}");
    const key = date.toISOString().slice(0,10);
    return data[key] || [];
  };
  const mockAddActivity = (date, activityObj) => {
    const data = JSON.parse(localStorage.getItem("calendarActivities") || "{}");
    const key = date.toISOString().slice(0,10);
    if (!data[key]) data[key] = [];
    data[key].push(activityObj);
    localStorage.setItem("calendarActivities", JSON.stringify(data));
  };

  useEffect(() => {
    setActivities(mockFetchActivities(selectedDate));
  }, [selectedDate]);

  // --- ใช้ userProfile จริงแทน IS_PREMIUM ---
  const isPremium = userProfile?.is_premium;

  const handleAddActivity = (e) => {
    e.preventDefault();
    setError("");
    if (!isPremium && !isDateWithin1Month(selectedDate)) {
      setError("บัญชีฟรีบันทึกกิจกรรมย้อนหลังได้ไม่เกิน 1 เดือน");
      return;
    }
    mockAddActivity(selectedDate, form);
    setForm({ activity: "", duration: "", note: "", category: "work" });
    setShowForm(false);
    setActivities(mockFetchActivities(selectedDate));
  };

  const categories = [
    { value: "work", label: "Work" },
    { value: "family", label: "Family" },
    { value: "health", label: "Health" },
    { value: "learning", label: "Learning" },
    { value: "rest", label: "Rest" },
    { value: "other", label: "Other" },
  ];

  return (
    <div className="max-w-4xl mx-auto p-6 mt-10 flex flex-col md:flex-row gap-8">
      {/* Calendar */}
      <div className="md:w-1/2 w-full flex flex-col items-center">
        <Calendar
          onChange={setSelectedDate}
          value={selectedDate}
          calendarType="ISO 8601"
        />
        <div className="mt-4 text-lg font-bold text-indigo-700">
          {selectedDate.toLocaleDateString()}
        </div>
        <button
          className="mt-4 px-4 py-2 rounded-xl font-bold bg-gradient-to-r from-pink-500 to-blue-400 text-white shadow hover:scale-105 transition"
          onClick={() => setShowForm(!showForm)}
        >
          + Add Activity
        </button>
      </div>

      {/* Activities & Add Form */}
      <div className="md:w-1/2 w-full">
        <h2 className="font-bold text-xl mb-4">Activities</h2>
        {activities.length === 0 && <div className="text-gray-500 mb-4">No activities</div>}
        <ul className="space-y-3 mb-6">
          {activities.map((a, i) => (
            <li key={i} className="bg-white rounded-xl shadow p-4">
              <div className="flex items-center gap-2">
                <span className="font-bold">{a.activity}</span>
                <span className="text-xs bg-gray-200 rounded px-2">{a.category}</span>
              </div>
              <div className="text-sm text-gray-500">{a.duration}</div>
              {a.note && <div className="text-gray-600">{a.note}</div>}
            </li>
          ))}
        </ul>

        {/* Inline Add Activity Form */}
        {showForm && (
          <form className="space-y-3 bg-white rounded-xl p-4 shadow" onSubmit={handleAddActivity}>
            <input
              className="w-full border rounded-xl px-3 py-2"
              type="text"
              placeholder="Activity"
              value={form.activity}
              onChange={e => setForm(f => ({ ...f, activity: e.target.value }))}
              required
            />
            <input
              className="w-full border rounded-xl px-3 py-2"
              type="text"
              placeholder="Duration (e.g., 1 hour, 30 min, 08:00-09:30)"
              value={form.duration}
              onChange={e => setForm(f => ({ ...f, duration: e.target.value }))}
            />
            <input
              className="w-full border rounded-xl px-3 py-2"
              type="text"
              placeholder="Note (optional)"
              value={form.note}
              onChange={e => setForm(f => ({ ...f, note: e.target.value }))}
            />
            <select
              className="w-full border rounded-xl px-3 py-2"
              value={form.category}
              onChange={e => setForm(f => ({ ...f, category: e.target.value }))}
            >
              {categories.map(c => (
                <option value={c.value} key={c.value}>{c.label}</option>
              ))}
            </select>
            {error && (
              <div className="text-red-500 text-center">
                {error}
                {!isPremium && (
                  <div className="mt-2">
                    <a
                      href="/subscribe"
                      className="text-blue-500 underline text-xs"
                    >
                      อัปเกรดเป็น Premium เพื่อปลดล็อก
                    </a>
                  </div>
                )}
              </div>
            )}
            <div className="flex gap-2">
              <button
                type="button"
                className="flex-1 px-4 py-2 rounded-xl bg-gray-100"
                onClick={() => setShowForm(false)}
              >Cancel</button>
              <button
                type="submit"
                className="flex-1 px-4 py-2 rounded-xl bg-gradient-to-r from-pink-500 to-blue-400 text-white font-bold"
              >Save</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}